/**
 * Skin quiz: keeps the finished answers for the current tab (sessionStorage) so
 * a reload or back/forward shows the result again, like re-POSTing the
 * WordPress /skin-quiz-final/ page. Any other visit starts the quiz fresh.
 *
 * Only answer codes and the first name are stored (no email); the routine is
 * matched again on restore so admin edits apply.
 */
(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  } else {
    root.SkinQuizSavedResult = api;
  }
})(typeof self !== 'undefined' ? self : this, function () {
  const KEY = 'skin-quiz:result';
  const VERSION = 1;
  const MAX_AGE_MS = 60 * 60 * 1000;
  const QUESTIONS = ['age', 'skin_type', 'concern', 'water'];

  function clear(storage) {
    try {
      if (storage) storage.removeItem(KEY);
    } catch (error) {
      // Storage blocked: nothing to clear.
    }
  }

  /** @param {{name: string, answers: Object<string, string>}} result answer codes by question */
  function save(storage, result, now = Date.now()) {
    if (!storage) return;
    try {
      storage.setItem(
        KEY,
        JSON.stringify({ v: VERSION, savedAt: now, name: result.name || '', answers: result.answers })
      );
    } catch (error) {
      // Storage blocked or full: the result just won't survive a reload.
    }
  }

  /** @returns {{name: string, answers: Object<string, string>} | null} */
  function load(storage, now = Date.now()) {
    if (!storage) return null;

    let data = null;
    try {
      const raw = storage.getItem(KEY);
      data = raw ? JSON.parse(raw) : null;
    } catch (error) {
      data = null;
    }

    const valid =
      data &&
      data.v === VERSION &&
      typeof data.savedAt === 'number' &&
      data.savedAt <= now &&
      now - data.savedAt <= MAX_AGE_MS &&
      data.answers &&
      QUESTIONS.every((question) => typeof data.answers[question] === 'string' && data.answers[question] !== '');

    if (!valid) {
      clear(storage);
      return null;
    }

    return {
      name: typeof data.name === 'string' ? data.name : '',
      answers: Object.fromEntries(QUESTIONS.map((question) => [question, data.answers[question]])),
    };
  }

  /** True for a reload or back/forward, the only visits that show a saved result. */
  function isReturnVisit(navigationEntry) {
    return Boolean(navigationEntry) && (navigationEntry.type === 'reload' || navigationEntry.type === 'back_forward');
  }

  return { save, load, clear, isReturnVisit, KEY, MAX_AGE_MS, QUESTIONS };
});
